// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bFyfg":[function(require,module,exports,__globalThis) {
var _indexCss = require("./index.css");
//import './**/*.@(js|jsx|ts|tsx)'
var _controlsTs = require("./advanced/controls.ts");
var _atomicDimensionTs = require("./atomic/atomic--dimension.ts");

},{"./index.css":"kWCQB","./advanced/controls.ts":"asfG4","./atomic/atomic--dimension.ts":"jtR5V"}],"kWCQB":[function() {},{}],"asfG4":[function(require,module,exports,__globalThis) {
/////////////////////////////////////////////////
// https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
let has_seen\uA4FDkey_usage\u2D67tab = false // so far
;
const DEBUG = false;
/////////////////////
window.addEventListener('keydown', function on\uA4FDkeydown(evt) {
    if (evt.keyCode === 9) {
        if (DEBUG) console.info(`[@offirmo-private/css--framework] Keyboard usage detected! (tab key)`);
        has_seen\uA4FDkey_usage\u2D67tab = true;
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', on\uA4FDkeydown);
    }
});

},{}],"jtR5V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _styleOnce = require("@offirmo-private/style-once");
var _styleOnceDefault = parcelHelpers.interopDefault(_styleOnce);
//console.log('Hello from atomic--dimension.ts!')
function adjust_css() {
    const referer = new URLSearchParams(window.location.search).get('ref');
    if (referer !== 'webmanifest') return;
    console.log("Hello from @offirmo-private/css--framework / atomic--dimension.tsx: dynamically tweaking some CSS: o\u22C4full-viewport for iOs pinned app...");
    (0, _styleOnceDefault.default)({
        id: 'pinned-webapp-adjustments--viewport',
        css: `
:root {
	/* see @offirmo-private/css--framework/src/atomic/atomic--dimension.css#L28
	 * pinned apps on iOs: dv* are not full screen
	 */
	--o\u{22C4}full-viewport__width: 100lvw;
	--o\u{22C4}full-viewport__height: 100lvh;
}
`
    });
}
adjust_css();

},{"@offirmo-private/style-once":"bD1jd","@parcel/transformer-js/src/esmodule-helpers.js":"fCxzd"}],"bD1jd":[function(require,module,exports,__globalThis) {
/////////////////////////////////////////////////
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Insert the specified CSS with the hinted "id".
 * Returns either the newly created element, or the one that already exists.
 *
 * @param {{ id: string, css?: string, href?:string, document?:Document }} options
 * @returns {HTMLElement}
 */ function style_once({ id, css, href, document = window.document }) {
    const existing\u203Felt = document.getElementById(id);
    if (existing\u203Felt) return existing\u203Felt;
    const element = (()=>{
        if (css && href) throw new Error('style_once(): conflicting css & href!');
        if (css) {
            const style\u203Felt = document.createElement('style');
            style\u203Felt.setAttribute('id', id);
            style\u203Felt.innerHTML = css;
            return style\u203Felt;
        }
        if (href) {
            const link\u203Felt = document.createElement('link');
            link\u203Felt.setAttribute('id', id);
            link\u203Felt.rel = 'stylesheet';
            link\u203Felt.href = href;
            return link\u203Felt;
        }
        throw new Error('style_once(): you must provide css or href!');
    })();
    document.head.appendChild(element);
    return element;
}
/////////////////////////////////////////////////
exports.default = style_once;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"fCxzd"}],"fCxzd":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"aCjZp":[function(require,module,exports,__globalThis) {
var _indexCss = require("./index.css"); // TODO one day? https://fdossena.com/?p=html5cool/smooth/i.frag

},{"./index.css":"1jwoW"}],"1jwoW":[function() {},{}]},[], null, "parcelRequire375b", {})

//# sourceMappingURL=privacy-policy.51eb8bda.js.map
